export function createController() {
  return {
    symbol: Symbol('Controller'),
    isActive() {
      return !!this.controller;
    },
    start() {
      this.stop();
      this.controller = new AbortController();
      return this.controller;
    },
    stop() {
      if (this.isActive()) {
        try {
          this.controller.abort();
        } catch (e) {
          void 0;
        }

        delete this.controller;
      }
    },
  };
}

Object.defineProperty(
  createController,
  Symbol.hasInstance,
  {
    value(object) {
      return (
        object !== null &&
        typeof object === 'object' &&
        typeof object.symbol === 'symbol' &&
        object.symbol.description === this().symbol.description
      );
    },
  }
);
